import React, { Fragment } from 'react'
import { styled } from '@mui/material/styles';
import BenefitsCard from './BenefitCard';
import benefitsStyles from './BenefitsStyles';
import Separator from '../Separator/Separator';
import Accordion from '../Accordion/Accordion';
import './Benefits.css';

type BenefitsProps = {
  slots: Array<{
    title: string;
    content: string;
  }>;
  title: string;
  description: string;
  variant?: 'primary' | 'secondary';
}

const StyledBenefits = styled('section')(({ theme }) => benefitsStyles);

const Benefits: React.FC<BenefitsProps> = (props) => {
  const {
    title,
    description,
    slots,
    variant = 'primary'
  } = props;
  
  const leftItems = slots.filter((item, index) => index % 2 === 0);
  const rightItems = slots.filter((item, index) => index % 2 !== 0);
  return (
    <Fragment>
      <section id="beneficios" className='relative h-40'>
        <div className="skewed"></div>
      </section>
      <StyledBenefits className={"flex items-center justify-center 2rem lg:pt-[3rem] lg:pb-[6rem] " + (variant === 'primary' ? 'bg-[#d6d6d6]' : 'bg-[#575757]')}>
        <div className="container">
          <div className="flex px-8 lg:px-0 flex-col lg:flex-row">
            <div className="static lg:sticky top-0 px-8 lg:w-[45%] h-fit pt-[5rem] lg:pt-[10rem] pb-[3rem]">
              <h2 className={"flex justify-center items-center text-center rounded-4xl text-3xl font-semibold "  + (variant === 'primary' ? 'text-black' : 'text-white')}>
                {title}
              </h2>
              <Separator className="mt-10 mb-2"/>
              <div className={"text-center px-6 pt-6 max-w-[30rem] mx-auto " + (variant === 'primary' ? 'text-black' : 'text-white')}>
                {description}
              </div>
            </div>
            <div className="hidden lg:flex items-center justify-between lg:pt-[5rem]">
              <div id="card-column-1" className="w-1/2">
                {leftItems.map((item, index) => 
                  <BenefitsCard
                    key={`left-${index}`}
                    primaryText={item.title}
                    secondaryText={item.content}
                  />
                )}
              </div>
              <div id="card-column-2" className="h-full">
                {rightItems.map((item, index) => 
                  <BenefitsCard
                    key={`right-${index}`}
                    primaryText={item.title}
                    secondaryText={item.content}
                  />
                )}
              </div>
            </div>
            <Accordion
              className="lg:hidden"
              slots={slots}
            />
          </div>
        </div>
      </StyledBenefits>
    </Fragment>
  )
}

export default Benefits;